import { useQuery } from '@tanstack/react-query'
import { getBrands } from '@/lib/queries/brands'

export default function ActiveBrandLabel({ brandId }: { brandId?: string }) {
  const enabled = !!brandId

  const { data: brands, isLoading } = useQuery({
    queryKey: ['brands'],
    queryFn: getBrands,
    enabled,
    staleTime: 60_000,
  })

  const brandName = brands?.find((b) => b._id === brandId)?.name

  if (!brandId) return null

  return (
    <div className="text-[11px] text-gray-600">
      {isLoading ? 'Brand: …' : `Brand: ${brandName || brandId}`}
    </div>
  )
}

